import React from 'react';
import { BsXLg } from 'react-icons/bs';

export const EmailTag = ({
	adr,
	allAdrs,
	setEmailAdrs,
	index
}: {
	adr: string;
	allAdrs: string[];
	setEmailAdrs: (tags: string[]) => void;
	index: number;
}) => {
	function removeTag() {
		const updatedAdrs = allAdrs.slice();
		updatedAdrs.splice(index, 1);
		setEmailAdrs(updatedAdrs);
	}

	return (
		<div
			className="flex relative justify-center items-center py-1.5 px-1 rounded-full w-fit transition-all duration-500 max-h-7
												bg-gray-400 dark:bg-gray-600 border-green-200 hover:bg-purple-600 hover:border-purple-400
												dark:hover:bg-purple-600 dark:hover:border-purple-400 cursor-pointer
												dark:text-gray-300 text-gray-600 hover:text-gray-200 group"
		>
			<div className="pb-1">
				<span className="text-xs font-bold mx-1">{adr}</span>

				<button
					className="absolute bottom-4 -right-2 btn-error btn-xs btn btn-circle shadow-md
								scale-0 origin-left group-hover:scale-100
								opacity-0 group-hover:opacity-100 transition-all duration-500 text-center cursor-pointer"
					onClick={(e) => {
						e.stopPropagation();
						removeTag();
					}}
				>
					<BsXLg size={8} />
				</button>
			</div>
		</div>
	);
};
